export default __webpack_public_path__ + "static/media/Asset 1@3x@1x.5c8b2357.png";